import React from "react";
import {
  Grid,
  FormControlLabel,
  Checkbox,
  Typography,
  Box,
  useTheme,
} from "@mui/material";

interface Props {
  config: any;
  onChange: (field: string, value: any) => void;
}

const DOWNLOAD_OPTIONS = [
  "downloadBGRExteriors",
  "downloadCroppedExteriors",
  "downloadDewarpedUndercarriage",
  "downloadFeaturedExteriors",
  "downloadManuals",
  "downloadPanos",
  "downloadRawExteriors",
  "downloadRawUndercarriage",
];

const DownloadSettingsForm: React.FC<Props> = ({ config, onChange }) => {
  const theme = useTheme();
  const red = theme.palette.status.accent;

  return (
    <Box>
      <Typography
        variant="subtitle1"
        sx={{ fontWeight: 600, mb: 1, color: red }}
      >
        Asset Download Settings
      </Typography>

      <Grid container spacing={1}>
        {DOWNLOAD_OPTIONS.map((option) => (
          <Grid item xs={12} sm={6} md={4} key={option}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={config[option] || false}
                  onChange={(e) => onChange(option, e.target.checked)}
                  sx={{
                    "&.Mui-checked": { color: red },
                  }}
                />
              }
              label={option.replace("download", "").replace(/([A-Z])/g, " $1")}
            />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default DownloadSettingsForm;
